import { useMenu } from "@/hooks/useMenu";
import { useUsuarioLogado } from "@/hooks/useUsuarioLogado";
import {
  BorderlessTableOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  OrderedListOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { App, Button, Dropdown, Grid, Layout, Typography } from "antd";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";
import styles from "./style.module.css";

export function Header({
  collapsed,
  setCollapsed,
}: {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const screens = Grid.useBreakpoint();
  const { modal } = App.useApp();
  const { signoutSilent } = useAuth();
  const navigate = useNavigate();
  const { atualizarMenuSelected, menuSelected } = useMenu();
  const { removeUsuarioLogado } = useUsuarioLogado();

  const handleLogout = () => {
    modal.confirm({
      title: `Tem certeza que deseja Sair do Inspeção Mobile? essa ação impedirá o uso do modo offline.`,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk: () => {
        atualizarMenuSelected(["inicio"]);

        signoutSilent({
          post_logout_redirect_uri: window.location.origin,
        });

        removeUsuarioLogado();
      },
    });
  };

  return (
    <Layout.Header
      className={styles["header-form"]}
      style={{ padding: !screens.lg && !screens.md ? "0px 20px" : "0px 20px" }}
    >
      <div style={{ width: "25%" }}>
        {!screens.lg && !screens.md ? (
          <Dropdown
            menu={{
              selectedKeys: menuSelected,
              onClick: (e) => {
                atualizarMenuSelected([e.key]);
              },
              items: [
                {
                  key: "inicio",
                  label: "Início",
                  icon: <HomeOutlined />,
                  onClick: () => navigate("/inicio"),
                },
                {
                  key: "analise-laboratorial",
                  label: "Análise Laboratorial",
                  icon: <BorderlessTableOutlined />,
                  children: [
                    {
                      key: "requisicao",
                      label: "Requisição",
                      onClick: () =>
                        navigate("/analises-laboratoriais/requisicoes/lista"),
                      icon: <OrderedListOutlined />,
                    },
                    {
                      key: "certificado",
                      label: "Certificado",
                      onClick: () =>
                        navigate("/analises-laboratoriais/certificados/lista"),
                      icon: <OrderedListOutlined />,
                    },
                  ],
                },
                {
                  key: "termo-notificacao",
                  label: "Termo de Notificação",
                  icon: <BorderlessTableOutlined />,
                  children: [
                    {
                      key: "termo-notificacao-cadastro",
                      label: "Cadastramento",
                      onClick: () => navigate("/termos-notificacao/lista"),
                      icon: <OrderedListOutlined />,
                    },
                    {
                      key: "termo-notificacao-plano-acao",
                      label: "Plano de Ação",
                      onClick: () => navigate("/termos-notificacao/plano-acao"),
                      icon: <OrderedListOutlined />,
                    },
                  ],
                },
                {
                  key: "RAM",
                  label: "RAM",
                  icon: <BorderlessTableOutlined />,
                  children: [
                    {
                      key: "ram-cadastro",
                      label: "Cadastramento",
                      onClick: () => navigate("/RAM/lista"),
                      icon: <OrderedListOutlined />,
                    },
                    {
                      key: "ram-plano-acao",
                      label: "Plano de Ação",
                      onClick: () => navigate("/RAM/plano-acao"),
                      icon: <OrderedListOutlined />,
                    },
                  ],
                },
                {
                  key: "perfil",
                  label: "Gerenciamento de Perfis",
                  icon: <TeamOutlined />,
                  onClick: () => navigate("/perfis"),
                },
              ],
            }}
            placement="bottom"
            trigger={["click"]}
          >
            <Button>
              <MenuOutlined />
            </Button>
          </Dropdown>
        ) : (
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
        )}
      </div>

      <Typography.Text
        className={styles["title-homolog"]}
        style={{
          fontSize: !screens.lg && !screens.md ? "14px" : "18px",
        }}
      ></Typography.Text>

      <div className={styles["container-notification-button-leave"]}>
        <Button
          type="primary"
          danger
          onClick={handleLogout}
          icon={<LogoutOutlined />}
        >
          Sair
        </Button>
      </div>
    </Layout.Header>
  );
}
